import { FieldType, ComponentType } from '~/shared/domain/models';
import type { ContentfulFieldText } from '~/services/origins/contentful';
import type { FieldTextSchema } from '~/shared/domain/models';

export const adaptFieldText = (field: ContentfulFieldText): FieldTextSchema => {
  if (!field?.fields) {
    throw new Error('Missing field text params');
  }

  const { fields } = field;

  return {
    componentType: ComponentType.FieldText,
    label: fields.label,
    name: fields.name,
    defaultValue: fields.defaultValue,
    placeholder: fields.placeholder,
    type: FieldType[fields.type],
    disabled: fields.disabled,
    validations: {
      required: fields.required,
      min: fields.min,
      max: fields.max,
      minLength: fields.minLength,
      maxLength: fields.maxLength,
    },
    messages: {
      error: fields.errorMessage,
      helperText: fields.helperMessage,
    },
  };
};
